import { Button, Card, Col, Form, Input, message, Row } from 'antd';
import React, { useState } from 'react'
import Footer from '../../../../../components/common/Footer';
import PageHeading from '../../../../../components/common/PageHeading';
import { Radio } from 'antd';
import { PlusCircleFilled } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import MessageBox from './MessageBox';
import RightBar from '../../../../../components/common/RightBar';

const BulkPortalCommunicationSettings = () => {
  const [editClicked, setEditClicked] = useState(false);
  const [enableDisable, setEnableDisable] = useState('disable');
  const [showAddMore, setShowAddMore] = useState(false);
  const [showEdit, setShowEdit] = useState(true);
  const [messages, setMessages] = useState([]);
  const [radioBtnResult, setRadioBtnResult] = useState('disable');
  const [formData, setFormData] = useState([]);

  const GeneralSettingsRightBar = [];

  const handleAddMessage = () => {

    const newMessage = {
      id: uuidv4(),
    };
    setMessages([...messages, newMessage]);
  };

  const handleDeleteMessage = (id) => {
    const updatedMessages = messages.filter((message) => message.id !== id);
    setMessages(updatedMessages);

  };
  const showEditBox = () => {
    setEditClicked(true);
    setShowEdit(false);
    console.log("enable")
    if (enableDisable === 'enable') {
      setShowAddMore(true);
    } else {
      setShowAddMore(false);
    }
  }
  const onChange = e => {
    setEnableDisable(e.target.value);
    console.log(e.target.value)
    if (e.target.value === 'enable') {
      setShowAddMore(true);
      setRadioBtnResult('enable')

    } else {
      setShowAddMore(false)
      setRadioBtnResult('disable')

    }
  };
  // const handleSave = () => {
  const onFinish = (values) => {
    if (radioBtnResult === 'enable') {
      if (messages.length <= 0) {
        console.log("empty");
      }
      else {
        console.log("not empty");

        const newData = { ...values, messages };
        setFormData([...formData, newData]);
        setEditClicked(false);
        setShowAddMore(false);
        setShowEdit(true);
      }
    }
    else {
      setEditClicked(false);
      setShowAddMore(false);
      setShowEdit(true);
    }
  };
  console.log("formData", formData)

  const handleDelete = () => {

    setEditClicked(false);
    setShowAddMore(false);
    setShowEdit(true);
  }

  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="Bulk Portal Communication Settings" />
          <Row>
            <Col span={24}>
              <Card
                title="Bulk Portal Communication Settings"
                extra={<a href="#" onClick={showEditBox}>{showEdit && "Edit"}</a>}
                style={{
                  width: '100%',
                }}
              >
                <p style={{ color: 'gray' }}>Bulk Portal Communication</p>

                {!editClicked && <Col style={{ margin: '10px' }}>{radioBtnResult}</Col>}

                {editClicked &&
                  <Form.Item
                    name="RadioButton"
                  >
                    <Col span={24} style={{ margin: '10px 0px 50px 10px' }}>
                      <Radio.Group onChange={onChange} value={enableDisable}>
                        <Radio value="enable">Enabled</Radio>
                        <Radio value="disable">Disabled</Radio>
                      </Radio.Group>
                    </Col>
                  </Form.Item>
                }
                <Form layout="vertical" onFinish={onFinish}>

                  {showAddMore && <Row gutter={[16, 16]}>
                    {messages.map((message) => (
                      <MessageBox key={message.id}
                        id={message.id}
                        onDelete={handleDeleteMessage} />
                    ))}
                  </Row>}

                  {showAddMore && <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button className='add-moreAvail' size='small'
                      icon={<PlusCircleFilled />}
                      onClick={handleAddMessage}
                    >Add Another Message</Button>
                  </Col>}

                  {editClicked &&
                    <Col span={24} className="form-action page-actions-container" style={{ display: 'flex' }}>
                      <Form.Item>
                        {/* <Button type="primary" htmlType="submit"
                        onClick={handleSave}>Save
                      </Button> */}

                        <Button type="primary" htmlType="submit">Save
                        </Button>

                      </Form.Item>
                      <Form.Item>
                        <Button onClick={handleDelete}
                        >Cancel</Button>
                      </Form.Item>
                    </Col>
                  }
                </Form>
              </Card>
            </Col>
          </Row>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={GeneralSettingsRightBar} />
      </div>
    </>



  )
}

export default BulkPortalCommunicationSettings;